import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/apt/region/[region]/error.tsx");
